var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import SelectFilter from "./SelectFilter";
import FormGroup from "../../DocumentForm/components/FormGroup";

import { NeedAuthorization } from "../../Auth";
import { Translate } from "../../I18N";
import { Icon } from "../../UI";






const filteredAggregation = (aggregations, key) => {var _aggregations$all, _aggregations$all$_pu;return (
    (
    ((aggregations === null || aggregations === void 0 ? void 0 : (_aggregations$all = aggregations.all) === null || _aggregations$all === void 0 ? void 0 : (_aggregations$all$_pu = _aggregations$all._published) === null || _aggregations$all$_pu === void 0 ? void 0 : _aggregations$all$_pu.buckets) || []).find((a) => a.key === key) || {
      filtered: { doc_count: 0 }
    }).
    filtered.doc_count || 0);};

const generateOptions = (aggregations) => [
{
  label: /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx(Icon, { icon: "globe-africa" }), "\xA0", /*#__PURE__*/

  _jsx(Translate, {}, void 0, "Published")
  ),

  title: 'Published',
  value: 'published',
  results: filteredAggregation(aggregations, 'true')
},
{
  label: /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx(Icon, { icon: "lock" }), "\xA0", /*#__PURE__*/

  _jsx(Translate, {}, void 0, "Restricted")
  ),

  title: 'Restricted',
  value: 'restricted',
  results: filteredAggregation(aggregations, 'false')
}];


const PublishedFilters = ({ onChange, aggregations }) => {
  const options = generateOptions(aggregations);
  const totalAggs = options.reduce((total, o) => total + o.results, 0);
  if (totalAggs === 0) {
    return null;
  }
  return /*#__PURE__*/(
    _jsx(NeedAuthorization, { roles: ['admin', 'editor', 'collaborator'] }, void 0, /*#__PURE__*/
    _jsx(FormGroup, { className: "admin-filter" }, "publishedStatus", /*#__PURE__*/
    _jsx(SelectFilter, {
      model: ".publishedStatus",
      prefix: "publishedStatus",
      onChange: onChange,
      options: options,
      showBoolSwitch: false }
    )
    )
    ));

};


export { PublishedFilters };